.zv4czv0 {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: subgrid;
  position: relative;
  padding: 10px 21px;
  background: var(--_6225erd);
  border-radius: var(--_6225erw);
  color: var(--_6225er4);
  text-decoration: none;
  font-weight: var(--_6225er20);
  font-size: var(--_6225er1z);
  transition: background 0.2s;
  gap: 16px;
}
.zv4czv2 {
  padding: 8px 14px;
  gap: 12px;
}
.zv4czv3 {
  cursor: pointer;
}
.zv4czv3:hover {
  background: var(--_6225era);
}
.zv4czv4 {
  background-color: var(--_6225era);
}
.zv4czv4:hover {
  background: var(--_6225era);
}
.zv4czv5 {
  position: relative;
  width: 40px;
  height: 40px;
  aspect-ratio: 1/1;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--_6225er5);
  color: var(--_6225er6);
  flex-shrink: 0;
  font-weight: var(--_6225er1m);
  cursor: default;
}
.zv4czv6 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}
.zv4czv7 {
  flex: 2;
}
.zv4czv8 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 13px;
}
.zv4czv9 {
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  min-width: 0;
}
.zv4czva {
  font-size: var(--_6225er1t);
  font-weight: var(--_6225er1u);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-flex;
  color: var(--_6225er4);
  text-decoration: none;
  gap: 8px;
}
.zv4czvb:hover {
  color: var(--_6225er5);
  text-decoration: underline;
}
.zv4czvc {
  font-size: var(--_6225er1i);
  font-weight: var(--_6225er1j);
}
.zv4czvd {
  font-size: var(--_6225er1i);
  font-weight: var(--_6225er22);
  max-width: 100%;
}
.zv4czve {
  font-size: var(--_6225er23);
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.zv4czvf {
  font-size: var(--_6225er1l);
  font-weight: var(--_6225er1m);
  color: var(--_6225erb);
  max-width: 100%;
}
.zv4czvg {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  min-width: 0;
}
.zv4czvh {
  color: var(--_6225er4);
  font-size: var(--_6225er1z);
  font-weight: var(--_6225er20);
  display: flex;
  flex-direction: column;
  gap: 8px;
  white-space: nowrap;
  justify-content: center;
  min-width: 0;
}
.zv4czv1 .zv4czvh {
  opacity: 0.5;
}
.zv4czvi {
  align-items: flex-end;
}
.zv4czvj {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.zv4czvk {
  font-size: var(--_6225er21);
  font-weight: var(--_6225er22);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}